import { FunctionComponent } from "react"

import { useAgentState } from "@/agent-state"

import { AgentStatusSwitcher } from "./agent-status-switcher"
import { useAgentStatusHook } from "./hook"

const AgentStatusSelect: FunctionComponent = () => {
  const { isDisabled: disableInManualCall, onChange } = useAgentStatusHook()
  const { state } = useAgentState()
  const displayStatus = state.context.displayStatus
  // when agent has a call report, disable the status change to prevent agent go-offline-and-skip
  const disableBeforeSaveCallReport =
    displayStatus === "online" &&
    state.matches({ busy: "after_call" }) &&
    !state.context.historyItem
  const isDisabled = disableInManualCall || disableBeforeSaveCallReport

  return (
    <AgentStatusSwitcher
      isDisabled={isDisabled}
      status={displayStatus}
      onChange={onChange}
      data-unmask
    />
  )
}

export default AgentStatusSelect
